import { Slide, SlideComponentProps } from '@/components/slides/Slide.tsx';
import React, { FC, useState } from 'react';
import { useShareOrRedirect } from '@/components/slides/Selfie/useShareOrRedirect.ts';
import { SelfieOverlay } from '@/components/slides/Selfie/SelfieOverlay.tsx';
import { translate } from '@/translation/translate.ts';
import { isIosSafari } from '@/util/isIosSafari.ts';
import { SelfieOverlayIos } from '@/components/slides/Selfie/iOS/SelfieOverlayIos.tsx';
import { useNavigation } from '@/navigation/NavigationContex.ts';

type SelfieProps = SlideComponentProps;

export const Selfie: FC<SelfieProps> = ({ ...props }) => {
  useShareOrRedirect();

  const [showSelfieOverlay, setShowSelfieOverlay] = useState<boolean>(false);
  const { next } = useNavigation();

  const isIos = isIosSafari();

  const toggle = () => {
    setShowSelfieOverlay((v) => !v);
  };

  const buttonTitle = translate(props.slide.selfiebutton);
  const nextButtonTitle = translate(props.slide.nobutton);

  return (
    <>
      {!showSelfieOverlay && (
        <Slide {...props}>
          <div className={'question-button-wrapper'}>
            <button className={'bordered button'} onClick={toggle}>
              {buttonTitle}
            </button>
            <button className={'bordered'} onClick={next}>
              {nextButtonTitle}
            </button>
          </div>
        </Slide>
      )}

      {showSelfieOverlay && !isIos && <SelfieOverlay onClose={toggle} />}
      {showSelfieOverlay && isIos && <SelfieOverlayIos onClose={toggle} />}
    </>
  );
};
